import { SVGProps } from 'react';

const Camera = ({
  width = 22,
  height = 18,
  fill = '#2A2A2A',
  ...otherProps
}: SVGProps<SVGSVGElement>) => (
  <svg
    height={height + 'px'}
    width={width + 'px'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 18"
    {...otherProps}>
    <path fillRule="evenodd" clipRule="evenodd" d="M14 0H8L6 2H3C1.34315 2 0 3.34315 0 5V15C0 16.6569 1.34315 18 3 18H19C20.6569 18 22 16.6569 22 15V5C22 3.34315 20.6569 2 19 2H16L14 0ZM2 5C2 4.44771 2.44772 4 3 4H7L9 2H13L15 4H19C19.5523 4 20 4.44772 20 5V15C20 15.5523 19.5523 16 19 16H3C2.44772 16 2 15.5523 2 15V5ZM16 10C16 12.7614 13.7614 15 11 15C8.23858 15 6 12.7614 6 10C6 7.23858 8.23858 5 11 5C13.7614 5 16 7.23858 16 10ZM14 10C14 11.6569 12.6569 13 11 13C9.34315 13 8 11.6569 8 10C8 8.34315 9.34315 7 11 7C12.6569 7 14 8.34315 14 10Z" fill={fill} />
  </svg>
);

export default Camera;
